import React from 'react';
import { connect } from 'react-redux';
import * as reducers from '../../store/reducers';
import { capitalize } from '../../utilities';

import styles from './AddStudentToClass.scss';
import AddStudentToClassForm from 'Containers/AddStudentToClassForm';
import AddStudentToSchoolForm from 'Containers/AddStudentToSchoolForm';

class AddStudent extends React.Component {
  componentDidMount() {
    // When the form opens, make sure it’s visible on the class page.
    if (this.props.groupType === 'class') {
      window.scrollTo(0, 220);
    }
  }

  render() {
    const { groupType, isFormFocused, isFormReadOnly } = this.props;
    const statusClass = isFormReadOnly ? ' is-readonly' : '';
    const focusClass = isFormFocused ? ' is-focused' : '';
    return (
      <div
        className={`AddStudent AddStudent--${groupType}${focusClass}${statusClass}`}
        ref={div => (this.containerDiv = div)}
      >
        <div className="AddStudent__container">
          {groupType === 'class' ? (
            <AddStudentToClassForm />
          ) : (
            <AddStudentToSchoolForm />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { groupType }) => {
  const formId = `addStudentTo${capitalize(groupType)}`;
  return {
    isFormFocused: reducers.getFocusedFormField(state, formId),
    isFormReadOnly: reducers.isFormReadOnly(state, formId),
  };
};

export default connect(mapStateToProps, false)(AddStudent);
